import {
  Box,
  Button,
  Field,
  Flex,
  Heading,
  Input,
  Link,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { ImageBasic } from "components/Image";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useState } from "react";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import { useDispatch } from "react-redux";
import { setUserData } from "../../redux";
import { ENV_NAME } from "config";

function Login() {
  const [isLoading, setIsLoading] = useState(false);

  const ismobile = useCheckMobileScreen();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [buildType] = useState(ENV_NAME === "development" ? " (dev)" : "");
  const dispatch = useDispatch();

  const getPermissionSt = async () => {
    return new Promise((resolve, reject) => {
      api
        .getHaspermission({
          permvalue: [
            "perm_account_view_all",
            "perm_account_view_theirs",
            "perm_group_create",
            "perm_group_edit",
            "perm_commission_sheet_view",
            "perm_commission_sheet_view_all",
            "perm_commission_rules_view_all",
            "perm_commission_rules_view_theirs",
            "perm_refunds_view",
            "perm_refund_rules_view",
            "perm_custom_pricing_allow",
            "perm_custom_pricing_create",
            "perm_pricing_view",
            "perm_settings_change_vat",
            "perm_perm_view_profile",
            "perm_payments_view",
            "perm_payment_received_view",
            "perm_schedule_view",
          ],
        })
        .then((res) => {
          console.log("getPermissionSt getHaspermission res", res);

          if (res?.status === 200) {
            resolve(res?.data || {});
          } else {
            resolve(false);
            toaster.create({
              title: res?.message,
              type: "error",
            });
          }
        });
    });
  };

  const onSucessLogin = async (res) => {
    setIsLoading(true);
    const permRes = await getPermissionSt();
    setIsLoading(false);
    if (permRes !== false) {
      window.localStorage.setItem(
        "loginRes",
        JSON.stringify({ ...res?.data, ...{ permStList: permRes || [] } })
      );
      dispatch(setUserData(res?.data));
    }
  };

  const onClickLogin = () => {
    setIsLoading(true);
    api.login({ username: username, password: password }).then((res) => {
      console.log("onClickLogin res", res);
      setIsLoading(false);
      if (res.status !== 200) {
        toaster.create({
          title:
            res?.response?.data?.message ||
            res?.response?.data ||
            res?.message ||
            "error",
          type: "error",
        });
      } else {
        if (res?.data?.active) {
          onSucessLogin(res);
        } else {
          toaster.create({
            title: "account not active",
            type: "error",
          });
        }
      }
    });
  };

  // useEffect(() => {
  //   let loginRes = window.localStorage.getItem("loginRes");
  //   loginRes = JSON.parse(loginRes);

  //   if (loginRes?.active) {
  //     dispatch(setUserData(loginRes));
  //     navigate("/home");
  //   }
  // }, [dispatch, navigate]);

  return (
    <Flex
      // h="100vh"
      flex={1}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      p={"2rem"}
    >
      <ImageBasic
        alignSelf={"center"}
        p={"30px"}
        src={"./img/img-brand-logo-dark.png"}
        h={"20rem"}
      />
      <Flex h={"2.5rem"} overflow={"hidden"}>
        {isLoading ? (
          <Spinner size="md" color="spinner" colorPalette={"spinner"} />
        ) : null}
      </Flex>
      <Heading textAlign={"center"} size="xl" color="fontdark" mb="8">
        Auto Union Warranties Ltd Online Login Page
      </Heading>
      <Flex gap="4" w={ismobile ? "100%" : "400px"} flexDirection={"column"}>
        <Field.Root orientation="horizontal">
          <Field.Label textStyle={"md"}>Username</Field.Label>
          {/* <Input flex="1" textStyle={"md"} /> */}
          <Input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            textStyle={"md"}
            placeholder="username or email"
          />
        </Field.Root>

        <Field.Root orientation="horizontal">
          <Field.Label textStyle={"md"}>Password</Field.Label>
          {/* <Inssput type="password" flex="1" textStyle={"md"} /> */}
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            textStyle={"md"}
          />
        </Field.Root>
        <Button onClick={onClickLogin} bg="text" size="lg">
          Login
        </Button>

        <Field.Root orientation="horizontal">
          <Box />
          <Link color={"link"} href="forgotpassword">
            forgot password
          </Link>
        </Field.Root>
      </Flex>
      <Text textAlign="center" color="text" mt="5%">
        2024 - AU Warranties Ltd {buildType}
      </Text>
    </Flex>
  );
}

export default Login;
